import { UI, Stack, VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { RouteProp, useRoute } from '@react-navigation/native';
import React, { useState } from 'react';

import { AllSignedInRoutes } from '../../../../routes/types';

import { leadCaptureAndConversionTabs } from './constants';

export interface LeadCaptureAndConversionProps {
  isMobile: boolean;
  isTablet: boolean;
}

export const LeadCaptureAndConversion: React.FC<LeadCaptureAndConversionProps> = ({
  isMobile,
  isTablet,
}) => {
  const { params } = useRoute<RouteProp<AllSignedInRoutes, 'Home'>>();
  const [activeTab, setActiveTab] = useState<number>(params?.initialTabIndex ?? 0);

  const TabComponent = leadCaptureAndConversionTabs[activeTab].component;

  return (
    <VStack>
      <Stack px={Spacing['inline.xxxs']}>
        <UI.Tabs
          testId="category-tabs"
          activeTab={activeTab}
          variant="secondary"
          onTabPress={(i) => setActiveTab(i)}
          tabs={leadCaptureAndConversionTabs}
        />
      </Stack>
      <TabComponent isMobile={isMobile} isTablet={isTablet} />
    </VStack>
  );
};
